import type { SupplyStatus } from '../network/protocol';

export function describeSupply(status: SupplyStatus): string | null {
  if (!status.available) return null;
  const seconds = Math.max(0, Math.ceil(status.arrivesIn));
  const minutes = Math.floor(seconds/60);
  const remainder = seconds%60;
  return `SUPPLY W${String(status.nextWave).padStart(2, '0')} // ${String(minutes).padStart(2, '0')}:${String(remainder).padStart(2, '0')}`;
}
